<div id="content" class="allcp-form" ng-controller="TeamController">
    <div ng-include="'modules/company/menus/user_menu.html'"></div>
    <div class="row mt20">
        <div class="panel mb25 mt5">
            <div class="panel-heading">
                <span class="panel-title"> Yeni Ekip</span>
                <hr>
            </div>
            <div class="panel-body pn">
                <form ng-submit="saveTeam()"  class="form-horizontal">
                    <div class="col-md-8">

                        <div class="form-group">
                            <label class="col-md-3 control-label">Ekip Adı : </label>
                            <div class="col-md-9">
                                <label for="name21" class="field prepend-icon">
                                    <input type="text" ng-model="team.name" class="event-name gui-input br-light light" required>
                                    <label for="name21" class="field-icon">
                                        <i class="fa fa-users"></i>
                                    </label>
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-md-3 control-label">Ekip Açıklaması : </label>
                            <div class="col-md-9">
                                <label for="name21" class="field prepend-icon">
                                    <textarea rows="5" cols="10" class="form-control" ng-model="team.description"></textarea>
                                    <label for="name21" class="field-icon">
                                        <i class="fa fa-paperclip"></i>
                                    </label>
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-md-3 control-label">
                                Konum Doğruluk ve Hız Derecesi : 
                                <a href="#" class="hint--medium hint--top-left" aria-label="Yüksek seçim şarj durumlarını etkileyebilir. Buradaki değişikliklerin uygulamalara yansıması biraz zaman alabilir."><i class="fa fa-question-circle"></i> </a>
                            </label>
                            <div class="col-md-9">
                                <label for="name21" class="field">
                                    <select ng-model="team.location_density" ng-init="team.location_density = 'high'" class="form-control">
                                        <option value="none">Canlı Takip Yok</option>
                                        <option value="low">Düşük</option>
                                        <option value="middle">Orta</option>
                                        <option value="high">Yüksek</option>
                                    </select>
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-md-3 control-label"></label>
                            <div class="col-md-9">
                                <button type="submit" class="btn btn-success pull-right"><span class="fa fa-save"></span> Kaydet</a>
                            </div>
                        </div>
                    </div>                        
                </form>
            </div>
        </div>
    </div>
</div>